import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import ModuleQuestion from "../../components/ModuleQuestion";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_1_0 = () => {
  const moduleNumber = 4;
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);


  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} moduleNumber={moduleNumber} />}

      <main className="col-sm-8 module-content">
        <section>
          <h1 className="blue text-uppercase b mt-5 mb-4">4.1.14 Case 14</h1>
          <p className="me-4">Estimated time to complete: 3-5 minutes</p>
        </section>
        <ModuleQuestion
          correctAnswer="A"
          assessmentName="challenge_case_14"
          videoTranscript={
            <>
              <p>
                <strong>AUDIO</strong>
                <br />
                VO: (FEMALE)
                <br />
                This is challenge case number 14. This is a positive case. You
                may notice that after loading this case, the contrast is set
                low. It is important to adjust the contrast to a more acceptable
                level prior to interpretation. Utilize the contrast option to
                adjust the contrast. Once this is done, you can start at the
                bottom of the brain near the cerebellum to review the scan.
              </p>
              <p>
                Entering into the temporal and occipital regions, distinct white-matter tracts are not identifiable bilaterally. Increased activity is seen in the gray matter, extending to the cortical rim, on both sides. Therefore, there is loss of gray-white contrast in the temporal and occipital regions. In the frontal cortices, seen here, a similar pattern is observed; there is loss of gray-white contrast bilaterally and white-matter tracts are not identifiable.
              </p>
              <p>
                Moving into the parietal region, identified here, once again there is loss of gray-white contrast in the posterior parietal region bilaterally, as well as in the lateral parietal region, on both sides. In the medial parietal region, identified here, which includes the precuneus, there is also increased activity in the gray matter. Reviewing the remainder of the slices in the parietal region also shows that there is loss of gray-white contrast throughout. As there is loss of contrast in the parietal, frontal, occipital, and temporal regions, this case is positive. If you called this case negative, you may want to review the case once again in the MIMcloud Viewer.
              </p>
            </>
          }
          previousLesson="/module-4/module-4-1-13"
          nextLesson="/module-4/module-4-1-15"
          iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_2064927905&entry_id=1_5j85p4zd&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
          videoId="1_5j85p4zd"
        />
      </main>
    </div>
  );
};

export default Module_1_0;
